export enum TypeVisionModule {
	GLOBAL_VISION = 0, // Global access
	GROUP_ACCESS_PERMISSION = 1 // Access limited by groups
}
